<template>
  <div class="container d-flex flex-column od-admin" style="margin-bottom: 100px;">
    <div class="admin-head mt-5 mb-5" v-if="user !== null">
      <div class="inner">
        <h2 class="admin-head-brand">오늘하루 치과<small class="text-muted ml-3">관리자 메뉴</small></h2>
        <nav class="nav nav-admin-head justify-content-center">
          <router-link :to="{name: 'adminContact'}" class="mr-3">{{ user.name }}</router-link>
          <router-link :to="{name: 'adminUser'}" class="mr-3">비밀번호 변경</router-link>
          <a style="cursor: pointer;" @click="logout">로그아웃</a>
        </nav>
      </div>
    </div>
    <div class="row">
      <template v-if="user !== null">
        <div class="col-sm-2">
          <admin-sidebar />
        </div>
        <div class="col-sm-10">
          <router-view />
        </div>
      </template>
      <template v-else>
        <div class="col-sm-12">
          <router-view />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AdminSidebar from './AdminSidebar.vue';

export default {
  name: 'Admin',
  components: { AdminSidebar },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    logout() {
      this.$store.dispatch('signout');
      this.$router.push({ name: 'adminLogin' });
    },
  },
};
</script>

<style lang="scss">
  .container {
    max-width: 100% !important;
  }

  .od-admin {
    font-family: "Noto Sans KR", "Nanum Gothic", 나눔고딕, 맑은고딕, "Malgun Gothic", "Apple SD Gothic Neo", sans-serif, Dotum;
    /*font-size: 16px !important;*/

    .form-control, .btn, .custom-control-input {
      /*font-size: 16px;*/
    }

    /*
    .custom-control-label::before {
      top: 4px;
      left: -16px;
      width: 16px;
      height: 16px;
    }

    .custom-control-label::after {
      top: 4px;
      left: -16px;
      width: 16px;
      height: 16px;
    }
    */

    @media (min-width: 576px) {
      &.container {
        max-width: 540px !important;
      }
    }

    @media (min-width: 768px) {
      &.container {
        max-width: 720px;
      }
    }

    @media (min-width: 992px) {
      &.container {
        max-width: 960px;
      }
    }

    @media (min-width: 1200px) {
      &.container {
        max-width: 1140px !important;
      }
    }

    .table {
      th, td {
        vertical-align: middle;
      }
    }

    .admin-head {
      margin-bottom: 2rem;

      .nav-link {
        padding: .25rem 0;
        color: #2c3e50;
        background-color: transparent;

        &:hover, &:focus {
        }

        &.router-link-active {
          font-weight: 700;
        }
      }

      .nav-link + .nav-link {
        margin-left: 1rem;
      }

      .active {
      }
    }

    .admin-head-brand {
      margin-bottom: 0;
    }

    @media (min-width: 48em) {
      .admin-head-brand {
        float: left;
      }
      .nav-admin-head {
        float: right;
      }
    }
  }

  /*
   * Header
   */

</style>
